module.exports = __webpack_public_path__ + "img/bangzhu.c35f3703.png";